import { render } from "./MediclaimTab.vue?vue&type=template&id=15f540a6&scoped=true"
import script from "./MediclaimTab.vue?vue&type=script&lang=js"
export * from "./MediclaimTab.vue?vue&type=script&lang=js"

import "./MediclaimTab.vue?vue&type=style&index=0&id=15f540a6&scoped=true&lang=scss"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f540a6"]])

export default __exports__